import client from './client';
import type { ItemType } from '@/types/api';

export const itemTypesApi = {
  getAll: async (includeInactive = false): Promise<ItemType[]> => {
    const response = await client.get<ItemType[]>('/item-types', {
      params: { includeInactive },
    });
    return response.data;
  },

  getById: async (id: string): Promise<ItemType> => {
    const response = await client.get<ItemType>(`/item-types/${id}`);
    return response.data;
  },

  create: async (data: Partial<ItemType>): Promise<ItemType> => {
    const response = await client.post<ItemType>('/item-types', data);
    return response.data;
  },

  update: async (id: string, data: Partial<ItemType>): Promise<ItemType> => {
    const response = await client.put<ItemType>(`/item-types/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await client.delete(`/item-types/${id}`);
  },

  seedDefaults: async (): Promise<void> => {
    await client.post('/item-types/seed');
  },
};
